<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter="$refs.table.refresh(true)">
          <a-row :gutter="24">
            <a-col :span="6" >
              <a-form-item label="师傅名称">
                <a-input v-model="queryParam.userName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item style="margin-left: 13px;"  label="联系方式">
                <a-input v-model="queryParam.phonenumber"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item  label="合同编号">
                <a-input v-model="queryParam.contractNo"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="合同名称">
                <a-input v-model="queryParam.contractName"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="合同状态">
                <a-select v-model="queryParam.forbiddenStatus"  @change="handleChange1">
                  <a-select-option value="0">正常</a-select-option>
                  <a-select-option value="1">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="合同有效期">
                <a-range-picker
                  v-model="queryParam1.time1"
                  style="width: 100%"
                  :ranges="{ '今天': [moment(), moment()], '本月': [moment(), moment().endOf('month')] }"
                  show-time
                  format="YYYY/MM/DD"
                  @change="onChange1"
                  @ok="onOk1"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅类型">
                <a-select v-model="queryParam.workerType"   @change="">
                  <a-select-option :title="i.label" v-for="i in restaurantTypes2" :key="i.code">
                    {{i.label}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅等级">
                <a-select v-model="queryParam.techLevel"   @change="">
                  <a-select-option :title="i.label" v-for="i in  tech_level" :key="i.code">
                    {{i.label}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="服务类别">
                <a-select v-model="queryParam.installType"    @change="">
                  <a-select-option :title="i.label" v-for="i in restaurantTypes" :key="i.code">
                    {{i.label}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="上传时间" style="margin-left: 13px;">
                <a-range-picker
                  v-model="queryParam1.time2"
                  style="width: 100%"
                  :ranges="{ '今天': [moment(), moment()], '本月': [moment(), moment().endOf('month')] }"
                  show-time
                  format="YYYY/MM/DD"
                  @change="onChange2"
                  @ok="onOk2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="操作人" style="margin-left: 13px;">
                <a-input v-model="queryParam.updateByName"></a-input>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row>
            <a-col :span="18"></a-col>
            <a-col :span="6" style="text-align: right">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearValues()">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        style="margin-top: 20px"
        size="default"
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 200 }"
        bordered
      >
      <span slot="action" slot-scope="text, record">
        <span v-if="detailsEnable">
          <a @click="seeData(record)">查看</a>
          <a-divider type="vertical"/>
          <a @click="download(record)">下载</a>
        </span>
        <a-divider v-if="detailsEnable && editEnabel" type="vertical"/>
        <!--编辑跳转师傅详情-->
        <span v-if="editEnabel">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a v-if="record.forbiddenStatus==`禁用`" @click="showState(record,record.forbiddenStatus)">启用</a>
          <a v-else @click="showState(record,record.forbiddenStatus)">禁用</a>
        </span>
        <a-divider v-if="removeEnable && detailsEnable || removeEnable && editEnabel" type="vertical"/>
        <a v-if="removeEnable" @click="delByIds(record.masterContractId)">删除</a>
        </span>
      </s-table>
      <masterlist-edit ref="modal" ></masterlist-edit>
      <p-d-fmodel ref="modal2"></p-d-fmodel>
    </a-card>
    <no-authority v-if="!queryList"></no-authority>
  </div>
</template>
<script>
  import moment from 'moment';
  import { STable } from '@/components'
  import { checkPermission } from '@/utils/permissions'
  import {queryMasterContract,GET,disableMasterContract,deleteMasterContract,enableMasterContract}  from '@/api/master/ContractManagement'
  import {getDictMap} from "../../utils/dict"
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import MasterlistEdit from './modules/MasterlistEdit.vue'
  import NoAuthority from '../enterprise/NoAuthority'
  import PDFmodel from './modules/PDFmodel.vue'
  export default {
    name: 'TableList',
    components: {
      STable,
      MasterlistEdit,
      PDFmodel,
      NoAuthority
    },
    data () {
      return {
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        fileType: 'pdf', // 文件类型
        src: '', // pdf文件地址
        visible5:false,//文件查看
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        queryParam1:{},
        // 表头
        columns: [
          {
            title: '操作栏',
            dataIndex: 'action',
            width:'80px',
            scopedSlots: { customRender: 'action'},
          }, {
            title: '师傅姓名',
            dataIndex: 'userName',
            align:'center',
          }, {
            title: '联系方式',
            dataIndex: 'phonenumber',
            align:'center',
          }, {
            title: '师傅类型',
            dataIndex: 'workerTypeName',
            align:'center',
          }, {
            title: '师傅等级',
            dataIndex: 'techLevelName',
            align:'center',
          }, {
            title: '服务类别',
            dataIndex: 'installName',
            align:'center',
          }, {
            title: '合同编号',
            dataIndex: 'contractNo',
            align:'center',
          }, {
            title: '合同名称',
            dataIndex: 'contractName',
            align:'center',
          }, {
            title: '合同有效期',
            dataIndex: 'contractDuration',
            align:'center',
          }, {
            title: '合同状态',
            dataIndex: 'forbiddenStatus',
            align:'center',
          }, {
            title: '师傅负责人',
            dataIndex: 'masterLeadingName',
            align:'center',
          }, {
            title: '渠道负责人',
            dataIndex: 'principalName',
            align:'center',
          }, {
            title: '操作人',
            dataIndex: 'updateByName',
            align:'center',
          }, {
            title: '上传时间',
            dataIndex: 'createTime',
            align:'center',
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        // loadData: parameter => {
        //   return queryMasterContract(Object.assign(parameter, this.queryParam))
        // },
        loadData: parameter => {
          return queryMasterContract(Object.assign(parameter, this.queryParam))
        },
        queryList: checkPermission('master:ContractManagement:query:list'),
        detailsEnable: checkPermission('master:ContractManagement:view:details'),
        editEnabel: checkPermission('master:ContractManagement:view:edit'),
        removeEnable: checkPermission('master:ContractManagement:view:delete'),
        tech_level:[],
      }
    },
    filters: {},
    async created () {
      // document.body.addEventListener('keyup', e => {
      //   if (e.keyCode == 13) {
      //     this.$refs.table.refresh(true)
      //   }
      // })
      this.restaurantTypes = [];//服务类别
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.restaurantTypes.push({code: key, label: value})
      });
      this.restaurantTypes2   = [];//师傅类别
      this.restaurantOperTypeMap = await getDictMap('worker_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.restaurantTypes2.push({code: key, label: value})
      });
      this.tech_level = [];//师傅等级
      this.restaurantOperTypeMap = await getDictMap('tech_level');
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.tech_level.push({code: key, label: value})
      })
    },
    // destroyed () {
    //   document.body.removeEventListener('keyup', e => {})
    // },
    methods: {
      moment,

      onChange1(value, dateString) {//合同有效期
        this.queryParam.contractStartTime=dateString[0]
        this.queryParam.contractEndTime=dateString[1]
      },
      onChange2(date,dateString) {//上传时间
        this.queryParam.uploadStartTime=dateString[0]
        this.queryParam.uploadEndTime=dateString[1]
      },
      //查看
      seeData(record){
        GET(record.masterContractId).then(res=>{
          console.log(res.data.contractAddresss)
          this.$refs.modal2.delsee(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + res.data.contractPdfAddresss + '&token=' + Vue.ls.get(ACCESS_TOKEN))
        })
      },
      //下载
      download(val){
        GET(val.masterContractId).then(res=>{
          window.open(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + res.data.contractAddresss + '&token=' + Vue.ls.get(ACCESS_TOKEN));
        })
      },
      delByIds (id) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            deleteMasterContract({ 'masterContractId':id}).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.handleOk()
              } else {
                that.$message.error(res.msg)
              }
            })
          },
        });
      },
      showState (val,id) {
        if (id == '正常') {
          disableMasterContract({ 'masterContractId':val.masterContractId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (id == '禁用') {
          enableMasterContract({ 'masterContractId':val.masterContractId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      clearValues() {//清空
        this.queryParam1={}
        this.queryParam={}
        this.$refs.table.refresh(true)
      },
      handleEdit (record) {
        this.$refs.modal.edit(record,'1')
      },
      handleOk () {
        this.$refs.table.refresh()
      },
    },
    watch: {
      /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
    }
  }
</script>

<style scoped>
  .twobtn{
    background-color: #409EFF;
    color: white;
    width: 110px;
    font-size: 15px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;  padding: 4px 16px;}
</style>
